import { render, staticRenderFns } from "./Jiandang.vue?vue&type=template&id=1a71eee7&scoped=true&"
import script from "./Jiandang.vue?vue&type=script&lang=js&"
export * from "./Jiandang.vue?vue&type=script&lang=js&"
import style0 from "./Jiandang.vue?vue&type=style&index=0&id=1a71eee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a71eee7",
  null
  
)

export default component.exports